export default __webpack_public_path__ + "static/student-app-6bf00344a5a9bba334ea3fe4b2f32435.mp4";